import PropTypes from 'prop-types';
import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {fetchIfNeeded, selectDataset} from "../store/actions";
import createWrapperMixin from "./createWrapperMixin";

import Error from "../components/Error.jsx";
import Mappable from "lib/Mappable";
import TimeFilter from "../lib/TimeFilter";

const keys = ["xKey", "yKey", "groupBy"];

export function createDataHandler(WrappedComponent) {
    let WrapperMixin = createWrapperMixin(WrappedComponent);
    return class DataHandler extends WrapperMixin {
        static propTypes = {
            chart: PropTypes.object,
            fetch: PropTypes.func.isRequired,
            datasets: PropTypes.object
        };

        static displayName = "DataHandler";

        constructor(props) {
            super(props);
            this.fetchDataset(props);
        }

        getDatasetName(props) {
            return (props.chart || {}).dataset;
        }

        getGranularity(props) {
            return (props.chart || {}).granularity;
        }

        getTimeSpan(props) {
            let span = TimeFilter.range((props.chart || {}).timespan, {timezone: props.timezone});

            if (span && span[1] > Date.now()) {
                span[1] = null;
            }

            return span;
        }

        getKeys(props) {
            let chart = props.chart || {};

            return Object.keys(chart)
                .filter(key => keys.includes(key))
                .map(key => chart[key]);
        }

        getDataset(props) {
            let name = this.getDatasetName(props);
            let granularity = this.getGranularity(props);
            let keys = this.getKeys(props);
            let timespan = this.getTimeSpan(props);
            return selectDataset(props.datasets, name, {granularity, keys, timespan});
        }

        fetchDataset(props) {
            let name = this.getDatasetName(props);
            let granularity = this.getGranularity(props);
            let keys = this.getKeys(props);
            let timespan = this.getTimeSpan(props);

            if (name && typeof name == "string") {
                props.fetch(name, {granularity, keys, timespan});
            }
        }

        getErrors(props) {
            let name = this.getDatasetName(props);
            let errors = [];

            if (name && typeof name !== "string") {
                errors.push("Invalid dataset url. (" + name + ")");
            }

            let dataset = this.getDataset(props);

            if (dataset && dataset.failed) {
                errors.push(dataset.reason);
            }

            return errors;
        }

        componentWillReceiveProps(nextProps) {
            let getId = props => {
                return this.getDatasetName(props)
                    + this.getGranularity(props)
                    + this.getKeys(props)
                    + this.getTimeSpan(props);
            };

            if (getId(this.props) !== getId(nextProps)) {
                this.fetchDataset(nextProps);
            }
        }

        render() {
            let passtrhough = new Mappable(this.props)
                .filter((value, key) => !["fetch", "datasets"].includes(key))
                .toObject();

            let props = {...passtrhough, dataset: this.getDataset(this.props)};
            let errors = this.getErrors(this.props)
                .map((msg, i) => {
                    return <Error key={i} msg={msg}/>;
                });

            return super.render(props, errors.length > 0 ? errors : null);
        }
    };
}

export default function createConnectedDataHandler(...args) {
    return connect(
        state => ({
            datasets: state.datasets
        }),
        dispatch => ({
            fetch: bindActionCreators(fetchIfNeeded, dispatch)
        })
    )(createDataHandler(...args));
}


// WEBPACK FOOTER //
// ./src/kpi/common/DataHandler.js